import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

// attach token for admin requests
client.interceptors.request.use((config) => {
  const token = localStorage.getItem("rb_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const api = {
  // public
  getSettings: () => client.get("/settings").then((r) => r.data),
  getCourses: () => client.get("/courses").then((r) => r.data),
  getGallery: () => client.get("/gallery").then((r) => r.data),
  getEvents: () => client.get("/events").then((r) => r.data),
  getTestimonials: () => client.get("/testimonials").then((r) => r.data),
  createEnquiry: (data) => client.post("/enquiries", data).then((r) => r.data),

  // auth
  login: (data) => client.post("/auth/login", data).then((r) => r.data),
  me: () => client.get("/auth/me").then((r) => r.data),

  // admin
  listEnquiries: () => client.get("/admin/enquiries").then((r) => r.data),
  deleteEnquiry: (id) => client.delete(`/admin/enquiries/${id}`).then((r) => r.data),
  updateSettings: (data) => client.put("/admin/settings", data).then((r) => r.data),

  create: (type, data) => client.post(`/admin/${type}`, data).then((r) => r.data),
  update: (type, id, data) => client.put(`/admin/${type}/${id}`, data).then((r) => r.data),
  remove: (type, id) => client.delete(`/admin/${type}/${id}`).then((r) => r.data),

  uploadFile: (file) => {
    const fd = new FormData();
    fd.append("file", file);
    return client
      .post("/admin/upload", fd, { headers: { "Content-Type": "multipart/form-data" } })
      .then((r) => `${BACKEND_URL}${r.data.url}`);
  },
};

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default client;
